(() => {
  window.UnobtrusiveFlash.showFlashMessage = (message, options) => {
    const config = { timeout: 0, ...options };

    // Workaround for common Rails flash type to match common Bootstrap alert type
    let alertType = "info";
    if (config.type === "alert") {
      alertType = "warning";
    } else if (config.type === "error") {
      alertType = "danger";
    }

    const $area = $(
      $(".flash-alert-area")[0] || $(".root-flash-alert-area")[0],
    );

    const animate = !$area.data("disable-animate");

    // Click-to-dismiss needs Bootstrap's JS, which landing pages deliberately
    // skip to stay lightweight. Everything else here works without it, so
    // degrade instead of throwing. Identical behavior wherever it is loaded.
    const dismissible = typeof $.fn.alert === "function";

    const btn = `
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `;

    const title = `
      <h5 class="alert-heading">${options.title}</h5>
    `;

    let alertMessage = message;

    // We have encoded links in our email confirmation flash message.
    if (alertMessage.includes("confirm your email")) {
      alertMessage = $("<div/>").html(alertMessage).text();
    }

    const $flash = $(`
      <div class="alert flash-alert alert-${alertType} fade show" role="alert">
        <i class="fa icon-${alertType}"></i>
        <div class="alert-content">
          ${options.title ? title : ""}
          ${alertMessage}
        </div>
        ${animate && dismissible ? btn : ""}
      </div>
    `);

    $area.prepend($flash);

    if (config.onClick) {
      $flash.attr("role", "button");
      $flash.on("click", (evt) => {
        // Make sure it's not the close button
        if (!$(evt.target).parents(".btn-close").length) {
          options.onClick(evt);
        }
      });
    }

    const $shown = animate ? $flash.hide().delay(300).slideDown(100) : $flash;
    if (dismissible) {
      $shown.alert();
    }

    if (animate && config.timeout > 0) {
      setTimeout(() => {
        if (dismissible) {
          $flash.slideUp(100).alert("close");
        } else {
          $flash.slideUp(100, () => $flash.remove());
        }
      }, config.timeout);
    }
  };

  $(window).bind("rails:flash", (e, params) => {
    window.UnobtrusiveFlash.showFlashMessage(params.message, {
      timeout: 4000,
      ...params,
    });
  });
})();
